import React, { ReactNode, useState } from 'react'
import { SfAccordionItem } from '@storefront-ui/react'
import { Image } from '@builder.io/react'
import { Transition } from 'react-transition-group'
import classNames from 'classnames'
import { icoCaretUpBlue, icoCaretDownBlue } from "resources/images"

interface AccordionSectionProps {
  title: string;
  amount: string | ReactNode;
  children: React.ReactNode;
  toggleOpenText?: string;
  toggleCloseText?: string;
  hideClose?: boolean;
  open?: boolean;
  setOpen?: React.Dispatch<React.SetStateAction<boolean>>
}

export default function AccordionSection({
  title,
  toggleOpenText = `More Details`,
  toggleCloseText = `Less Details`,
  amount,
  hideClose,
  open,
  setOpen,
  children
}: AccordionSectionProps ) {
  const [ isOpen, setIsOpen ] = useState( false )
  const [ isTransitioning, setTransitioning ] = useState( false )

  const handleToggle = () => {
    setTransitioning( true )
    setOpen ? setOpen( !open ) : setIsOpen( !isOpen )
  }

  const handleStopTransition = () => {
    setTransitioning( false )
  }

  return (
    <div className="bg-[#F3F5F7] py-5 px-5 inline-block w-full rounded-lg">
      <SfAccordionItem
        className="mb-3 list-none"
        summaryClassName="marker:hidden"
        summary={
          <div className="inline-block w-full text-graphite">
            <p className="float-left text-base md:text-lg">{title}</p>
            <p className="float-right font-semibold text-base md:text-lg">
              {amount}
            </p>
          </div>
        }
        open={isTransitioning || isOpen || open}
        onToggle={handleToggle}
      >
        <Transition
          in={open ?? isOpen}
          timeout={300}
          onEntered={handleStopTransition}
          onExited={handleStopTransition}
          mountOnEnter
          unmountOnExit
        >
          {( state ) => (
            <div
              className={classNames(
                `grid transition-[grid-template-rows] duration-300 grid-rows-[0fr]`,
                {
                  '!grid-rows-[1fr]':
                    state === `entering` || state === `entered`,
                  'grid-rows-[0fr]': state === `exiting`
                }
              )}
            >
              <div>{children}</div>
            </div>
          )}
        </Transition>
      </SfAccordionItem>
      {
        !hideClose && (
          <div className="cursor-pointer" onClick={handleToggle}>
            <span className="text-deepSleepBlue inline-flex items-center gap-2">

              <p className="text-sm md:text-base border-b border-deepSleep">
                {( open ?? isOpen ) ? toggleCloseText : toggleOpenText}
              </p>

              <Image
                src={
                  !( open ?? isOpen )
                    ? icoCaretDownBlue
                    : icoCaretUpBlue
                }
                alt="Caret Down"
                width={16}
                height={16}
              />
            </span>
          </div>
        )
      }

    </div>
  )
}
